import React, { useCallback, useEffect } from "react";
import Lottie from "lottie-react";
import introScribeAnimation from "assets/lotties/scribe/introScribeAnimation.json";
import loopScribeAnimation from "assets/lotties/scribe/loopScribaAnimation.json";
import writingScribaAnimation from "assets/lotties/scribe/writingScribaAnimation.json";
import reactionBox from "assets/images/reaction-box.png";
import useNavigation from "hooks/useNavigation";
import { useFormContext } from "contexts/form/form-provider";
import QRCodeScribe from "components/scribe/qr-code-scribe";
import { useLayoutContext } from "layout/layout-provider";
import { useScribeContext } from "contexts/scribe/scribe-provider";

type Props = {
  canBeClicked?: boolean;
};

const reactionScaleBase = 0.8;

const Scribe: React.FC<Props> = ({ canBeClicked = false }) => {
  const [showReactionAnimation, setShowReactionAnimation] =
    React.useState<boolean>(false);
  const [reactionBoxStyle, setReactionBoxStyle] = React.useState<{
    scale: number;
    bottom: number;
    right: number;
  }>({
    scale: reactionScaleBase,
    bottom: 0,
    right: 0,
  });

  const {
    switchToQrCodeScribe,
    setShowWritingAnimation,
    showWritingAnimation, setSwitchToQrCodeScribe, hideScribaIntro, setHideScribaIntro,
  } = useScribeContext();

  const { inputValue } = useFormContext();

  const { navigateToResult } = useNavigation();

  const goToResultPage = useCallback(() => {
    navigateToResult(inputValue);
  }, [inputValue, navigateToResult]);

  const onIntroAnimationComplete = useCallback(() => {
    setHideScribaIntro(true);
  }, [setHideScribaIntro]);

  const onClick = () => {
    if (canBeClicked) {
      setShowReactionAnimation(true);

      const scribeLoopAnimationElement = document.getElementById(
        "scribe-loop-animation",
      );

      if (!scribeLoopAnimationElement) {
        return;
      }

      const scale =
        scribeLoopAnimationElement.getBoundingClientRect().width / 800;
      setReactionBoxStyle((prev) => ({
        ...prev,
        scale: scale * reactionScaleBase,
      }));

      setTimeout(() => {
        setShowReactionAnimation(false);
      }, 3000);
    }
  };

  //TODO: ovviamente - chiamato onconplete del writing
  const fromFormToResult = useCallback(() => {
    setShowWritingAnimation(false); //qui viene messa a false
    setSwitchToQrCodeScribe(true);
    //TODO: lo sto iniizalizzando quando vado in result.

  }, [ setShowWritingAnimation, setSwitchToQrCodeScribe]);


  // Add a useEffect to handle the appearance and disappearance of the reactionBox
  useEffect(() => {
    const reactionBoxElement = document.getElementById("reaction-box");

    if (reactionBoxElement) {
      if (showReactionAnimation) {
        // Triggering the fade-in effect
        reactionBoxElement.style.opacity = "1";
      } else {
        // Triggering the fade-out effect
        reactionBoxElement.style.opacity = "0";
      }
    }
  }, [showReactionAnimation]);

  //scala del reactionbox
  useEffect(() => {
    const scribeLoopAnimationElement = document.getElementById(
      "scribe-loop-animation",
    );

    if (!scribeLoopAnimationElement) {
      return;
    }

    const bottom =
      scribeLoopAnimationElement.getBoundingClientRect().height + 15;

    setReactionBoxStyle((prev) => ({
      ...prev,
      bottom,
    }));
  }, [reactionBoxStyle.scale]);

  return (
    <>
      {!switchToQrCodeScribe && (
        <div className="relative height-100">
          {showWritingAnimation && (
            <Lottie
              animationData={writingScribaAnimation}
              autoplay={true}
              loop={false}
              className="lottie-animation absolute bottom-0 right-0"
              onComplete={fromFormToResult}
            />
          )}
          {!showWritingAnimation && (
            <>
              <img
                src={reactionBox}
                alt="scribe saying hello in english, italian and hieroglyphic (message box)"
                style={{
                  transform: `scale(${reactionBoxStyle.scale})`,
                  transition: "opacity 0.5s ease-in-out",
                  opacity: showReactionAnimation ? "1" : "0",
                  bottom: reactionBoxStyle.bottom,
                }}
                className={`absolute ${
                  window.innerWidth > 1140 && window.innerWidth < 1635
                    ? "origin-bottom"
                    : window.innerWidth <= 1140
                      ? "origin-bottom-left"
                      : "origin-bottom-right"
                }`}
              />

              {!hideScribaIntro && (
                <Lottie
                  animationData={introScribeAnimation}
                  autoplay={true}
                  loop={false}
                  className="lottie-animation absolute bottom-0 right-0"
                  onComplete={onIntroAnimationComplete}
                />
              )}
              {hideScribaIntro && (
                <Lottie
                  animationData={loopScribeAnimation}
                  autoplay={true}
                  loop={true}
                  id="scribe-loop-animation"
                  className={`lottie-animation absolute bottom-0 right-0${
                    canBeClicked ? " cursor-pointer" : ""
                  }`}
                  onClick={onClick}
                />
              )}
            </>
          )}
        </div>
      )}
      {switchToQrCodeScribe && <QRCodeScribe />}
    </>
  );
};

export default Scribe;
